/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonStorageUploadFromJSON, InternalCommonStorageUploadToJSON, } from './InternalCommonStorageUpload';
import { InternalCommonCommentableTypesFromJSON, InternalCommonCommentableTypesToJSON, } from './InternalCommonCommentableTypes';
import { InternalCommonCommentBaseFromJSON, InternalCommonCommentBaseToJSON, } from './InternalCommonCommentBase';
/**
 * Check if a given object implements the InternalUserCommentResponseV3 interface.
 */
export function instanceOfInternalUserCommentResponseV3(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('parentType' in value) || value['parentType'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('uploads' in value) || value['uploads'] === undefined)
        return false;
    if (!('attachments' in value) || value['attachments'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('repliesCount' in value) || value['repliesCount'] === undefined)
        return false;
    if (!('votesCount' in value) || value['votesCount'] === undefined)
        return false;
    if (!('likesCount' in value) || value['likesCount'] === undefined)
        return false;
    if (!('currentUserLikeId' in value) || value['currentUserLikeId'] === undefined)
        return false;
    if (!('replies' in value) || value['replies'] === undefined)
        return false;
    if (!('isReply' in value) || value['isReply'] === undefined)
        return false;
    return true;
}
export function InternalUserCommentResponseV3FromJSON(json) {
    return InternalUserCommentResponseV3FromJSONTyped(json, false);
}
export function InternalUserCommentResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'content': json['content'],
        'parentType': InternalCommonCommentableTypesFromJSON(json['parent_type']),
        'parentId': json['parent_id'],
        'userId': json['user_id'],
        'uploads': (json['uploads'].map(InternalCommonStorageUploadFromJSON)),
        'attachments': (json['attachments'].map(InternalCommonStorageUploadFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'repliesCount': json['replies_count'],
        'votesCount': json['votes_count'],
        'likesCount': json['likes_count'],
        'currentUserLikeId': json['current_user_like_id'],
        'replies': (json['replies'].map(InternalCommonCommentBaseFromJSON)),
        'isReply': json['is_reply'],
    };
}
export function InternalUserCommentResponseV3ToJSON(json) {
    return InternalUserCommentResponseV3ToJSONTyped(json, false);
}
export function InternalUserCommentResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'parent_type': InternalCommonCommentableTypesToJSON(value['parentType']),
        'parent_id': value['parentId'],
        'uploads': (value['uploads'].map(InternalCommonStorageUploadToJSON)),
        'attachments': (value['attachments'].map(InternalCommonStorageUploadToJSON)),
        'replies': (value['replies'].map(InternalCommonCommentBaseToJSON)),
    };
}
